export default "__VITE_ASSET__BsEdZC6G__"